module.exports = __webpack_public_path__ + "img/cubiertos.03e2884b.jpg";